import gql from "graphql-tag";
import { ReportOverview as _ReportOverview, ReportOverview_reports } from "./types/ReportOverview";

export const QUERY_REPORT_OVERVIEW = gql`
  query ReportOverview {
    reports {
      id
      secret
      report_number
      name
      step
      dataProgress
      dataValidation
      created_at
      report_complete
      ownerCompany
      sheets {
        product {
          customer
        }
      }
    }
  }
`;

export type ReportOverviewQueryResult = _ReportOverview;
export type ReportOverview = ReportOverview_reports & { splittedReportNumber?: SplittedReportNumber };

interface SplittedReportNumber {
  c: string;
  y: string;
  n: string;
}
